import { createRouter, createWebHistory } from 'vue-router';
import routes from './routes.js';

export { routes };

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.afterEach(to => {
  document.title = to.meta?.title || 'KATE Applicant Portal';
});

export default router;
